export default __webpack_public_path__ + "static/media/nft-card-front01.769478e0.png";